import {useQuery} from "@tanstack/react-query";
import getGameCarousels from "../services/games/gameCarousels/getGameCarousels.service";

const useGetGameCarousels = () => {
  const {data, isError, isLoading, isSuccess, refetch, error} = useQuery({
    queryKey: ["gameCarousels"],
    queryFn: getGameCarousels,
    staleTime: 5 * 60 * 1000,
    select: responseData => {
      const carousels = responseData?.data?.data?.carousels;
      return Array.isArray(carousels) ? carousels : [];
    },
  });

  return {
    promos: data || [],
    isError,
    isLoading,
    isSuccess,
    refetch,
    error,
  };
};

export default useGetGameCarousels;
